import React from 'react';

const toneClass = {
  ok: 'text-[#79fbb0]',
  warn: 'text-[#f6d978]',
  danger: 'text-[#ff9d9d]',
  info: 'text-[#bdeeff]',
  neutral: 'cc-text-primary',
};

export default function StatCard({ title, value, note, trend, tone = 'ok' }) {
  return (
    <div className="cc-tonal-panel-soft p-4">
      <p className="cc-text-muted text-[10px] uppercase tracking-[0.14em]">{title}</p>
      <p className={`mt-2 text-3xl font-semibold tracking-tight ${toneClass[tone] || toneClass.neutral}`}>{value}</p>
      {note ? <p className="cc-text-muted mt-1 text-xs">{note}</p> : null}
      {trend ? <p className="cc-text-secondary mt-2 text-xs font-medium">{trend}</p> : null}
    </div>
  );
}
